__turbopack_context__.v({
  "button": "CheckoutButton-module-scss-module__I9xH_q__button",
});
